<template>
  <div class="modal fade" id="cardFormModal" tabindex="-1" aria-labelledby="cardFormModalLabel"
    :aria-hidden="!isModalVisible">
    <div class="modal-dialog custom-modal-dialog modal-dialog-scrollable">
      <div class="modal-content border-0 shadow-lg">
        <div class="modal-header bg-white border-bottom-0 pb-0">
          <div>
            <h5 class="modal-title fw-bold text-primary mb-1" id="cardFormModalLabel">
              <i :class="isEditing ? 'bi bi-pencil-square' : 'bi bi-plus-circle'" class="me-2"></i>
              {{ isEditing ? "Editar Tarjeta" : "Nueva Tarjeta" }}
            </h5>
            <p class="text-muted small mb-0">Configure el contenido y estilo de la tarjeta.</p>
          </div>
          <button type="button" class="btn-close" @click="closeForm" aria-label="Close"></button>
        </div>

        <div class="modal-body pt-4">
          <form @submit.prevent="submitForm">

            <div class="fade-in">
              <h6 class="text-muted border-bottom pb-2 mb-4 small fw-bold text-uppercase">
                Información General
              </h6>

              <div class="row g-3 mb-4">
                <div class="col-md-9">
                  <div class="form-floating position-relative">
                    <input type="text" v-model="form.title" class="form-control pe-5" id="title" placeholder="Título"
                      required />
                    <label for="title">Título</label>
                    <i class="bi bi-info-circle text-primary input-info-icon" @click.stop="showHelp('title_card')"
                      title="Ver ayuda"></i>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-floating">
                    <input type="color" v-model="form.color" class="form-control form-control-color w-100" id="color"
                      title="Color de fondo" required style="height: 58px; padding-top: 2rem;" />
                    <label for="color">Color</label>
                  </div>
                </div>
              </div>

              <div class="row g-3 mb-4">
                <div class="col-12">
                  <div class="form-floating position-relative">
                    <textarea v-model="form.content" class="form-control pe-5" id="content" placeholder="Contenido"
                      style="height: 100px" maxlength="70" required @input="validateContentLength"></textarea>
                    <label for="content">Contenido</label>
                    <i class="bi bi-info-circle text-primary input-info-icon" @click.stop="showHelp('content_card')"
                      title="Ver ayuda"></i>
                  </div>
                  <div class="text-end mt-1">
                    <small :class="form.content.length === 70 ? 'text-danger fw-bold' : 'text-muted'">
                      {{ form.content.length }}/70 caracteres
                    </small>
                  </div>
                </div>
              </div>

              <div class="row g-3 mb-4">
                <div class="col-md-6">
                  <div class="form-floating position-relative">
                    <input type="text" v-model="form.button_text" class="form-control" id="button_text"
                      placeholder="Ej: Ver más" />
                    <label for="button_text">Texto Botón (Opcional)</label>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-floating">
                    <input type="number" v-model="form.order" class="form-control" id="order" placeholder="0"
                      required />
                    <label for="order">Orden de Visualización</label>
                  </div>
                </div>
              </div>

              <div class="p-4 bg-light rounded-3 border mb-4">
                <div class="text-center mb-3">
                  <label class="form-label text-uppercase text-muted fw-bold small tracking-wide">
                    Configuración de Destino
                  </label>
                  <div class="d-flex justify-content-center">
                    <div class="btn-group shadow-sm bg-white rounded" role="group" style="min-width: 300px;">
                      <input type="radio" class="btn-check" name="linkType" id="linkType1" value="link"
                        v-model="form.linkType">
                      <label class="btn btn-outline-primary px-4 py-2" for="linkType1">
                        <i class="bi bi-link-45deg fs-5 align-middle"></i> Enlace
                      </label>

                      <input type="radio" class="btn-check" name="linkType" id="linkType2" value="pdf"
                        v-model="form.linkType">
                      <label class="btn btn-outline-primary px-4 py-2" for="linkType2">
                        <i class="bi bi-file-earmark-pdf fs-5 align-middle"></i> PDF
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="form.linkType === 'link'">
                  <div class="col-12">
                    <div class="form-floating">
                      <input type="text" v-model="form.link" class="form-control bg-white" id="link"
                        placeholder="https://" required />
                      <label for="link" class="text-muted">URL de redirección</label>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="form.linkType === 'pdf'">
                  <div class="col-12">
                    <FileUploadPreview label="Seleccionar PDF" id="file" accept="application/pdf" :file="form.file"
                      :preview="form.file ? form.file.name : ''" :required="!isEditing"
                      @file-change="updateFile('file', $event)" no-file-message="Haga clic para subir el PDF"
                      class="clean-upload" />
                  </div>
                </div>
              </div>

              <h6 class="text-muted border-bottom pb-2 mb-3 small fw-bold text-uppercase">Multimedia</h6>

              <div class="row g-3 mb-4">
                <div class="col-12">
                  <FileUploadPreview label="Imagen Principal" id="image" accept="image/*" :file="form.image"
                    :preview="form.imagePreview" :required="!isEditing" @file-change="updateFile('image', $event)"
                    no-file-message="Imagen de fondo" helpId="image_card" @show-help="showHelp" class="clean-upload" />
                </div>

                <div class="col-12">
                  <FileUploadPreview label="Icono" id="icon" accept="image/*" :file="form.icon"
                    :preview="form.iconPreview" :required="!isEditing" @file-change="updateFile('icon', $event)"
                    no-file-message="Icono representativo" helpId="icon_card" @show-help="showHelp"
                    class="clean-upload" />
                </div>
              </div>

              <div class="d-flex justify-content-end mt-4 pt-3 border-top">
                <button type="submit" class="btn btn-primary px-5 rounded-pill shadow-sm">
                  <i class="bi bi-check-lg me-2"></i>
                  {{ isEditing ? "Guardar Cambios" : "Crear Tarjeta" }}
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>

    <HelpModal v-if="helpField" :field="helpField" @close="helpField = null" />
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { Modal } from "bootstrap";
import { createCard, updateCard } from "@/services/api/cardService.js";
import FileUploadPreview from "@/components/shared/FileUploadPreview.vue";
import userConfirmation from "@/utils/userConfirmation.js";
import HelpModal from "@/components/shared/HelpModal.vue";
import { buildFormData } from "@/utils/formDataBuilder.js";
import { showLoadingAlert, closeLoadingAlert } from "@/utils/loadingAlert.js";

export default {
  components: {
    FileUploadPreview,
    HelpModal,
  },
  props: {
    view: { type: Object, required: true },
    header: { type: Object, default: null },
  },
  setup(props, { emit }) {
    const helpField = ref(null);
    const isModalVisible = ref(false);
    const isEditing = ref(false);

    const form = ref({
      title: "",
      content: "",
      link: "",
      button_text: "",
      file: null,
      image: null,
      icon: null,
      order: "",
      color: "#ffffff",
      iconPreview: "",
      imagePreview: "",
      view_id: props.view.id,
      linkType: "link",
    });

    watch(
      () => props.header,
      (newHeader) => {
        if (newHeader) {
          isEditing.value = true;
          form.value = {
            title: newHeader.title,
            content: newHeader.content,
            link: newHeader.link,
            button_text: newHeader.button_text || "",
            file: newHeader.file || null,
            image: null,
            icon: null,
            order: newHeader.order,
            color: newHeader.color || "#ffffff",
            iconPreview: newHeader.icon,
            imagePreview: newHeader.image,
            view_id: newHeader.view.id,
            linkType: newHeader.link ? "link" : newHeader.file ? "pdf" : "link",
          };
        } else {
          isEditing.value = false;
          form.value = {
            title: "",
            content: "",
            link: "",
            button_text: "",
            file: null,
            image: null,
            icon: null,
            order: "",
            color: "#ffffff",
            iconPreview: "",
            imagePreview: "",
            view_id: props.view.id,
            linkType: "link",
          };
        }
      },
      { immediate: true }
    );

    const updateFile = (type, file) => {
      form.value[type] = file;
    };

    const submitForm = async () => {
      if (form.value.linkType === "link") {
        form.value.file = null;
      } else if (form.value.linkType === "pdf") {
        form.value.link = null;
      }

      const formData = buildFormData(form.value, form.value.linkType);

      const editOrCreate = isEditing.value ? "editar" : "crear";
      const confirmed = await userConfirmation(
        `¿Está seguro de ${editOrCreate} la tarjeta?`
      );

      if (!confirmed) return;

      showLoadingAlert();
      try {
        if (isEditing.value) {
          await updateCard(props.header.id, formData);
          emit("success", "Card actualizado exitosamente.");
        } else {
          await createCard(formData);
          emit("success", "Card creado exitosamente.");
        }

        emit("card-created");
        closeForm();
      } catch (error) {
        emit(
          "error",
          error.response?.data?.message || "Error al procesar la solicitud."
        );
      } finally {
        closeLoadingAlert();
      }
    };

    const showHelp = (field) => {
      helpField.value = field;
    };

    const validateContentLength = () => {
      if (form.value.content && form.value.content.length > 70) {
        form.value.content = form.value.content.slice(0, 70);
      }
    };

    const closeForm = () => {
      isModalVisible.value = false;
      emit("close");
      const modalElement = document.getElementById("cardFormModal");
      const modalInstance = Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    };

    onMounted(() => {
      const modalElement = document.getElementById("cardFormModal");
       const modalInstance = new Modal(modalElement, {
        backdrop: 'static',
        keyboard: false
      });
      modalInstance.show();
      isModalVisible.value = true;
    });

    return {
      form,
      isEditing,
      updateFile,
      submitForm,
      closeForm,
      isModalVisible,
      showHelp,
      helpField,
      validateContentLength,
    };
  },
};
</script>

<style scoped>
.input-info-icon {
  position: absolute;
  top: 18px;
  right: 15px;
  cursor: pointer;
  z-index: 5;
  font-size: 1.1rem;
}

.form-floating textarea~.input-info-icon {
  top: 15px;
}

.custom-modal-dialog {
  max-width: 700px;
  margin: 1.75rem auto;
}

.fade-in {
  animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

::v-deep .clean-upload .border {
  background-color: #f8f9fa !important;
  border: 2px dashed #dee2e6 !important;
  color: #6c757d !important;
  transition: all 0.3s;
}

::v-deep .clean-upload .border:hover {
  background-color: #e9ecef !important;
  border-color: #adb5bd !important;
}

.form-control-color {
  max-width: 100%;
}

@media (max-width: 768px) {
  .custom-modal-dialog {
    max-width: 95%;
    margin: 10px auto;
  }
}
</style>